import React from 'react'

/**
 * This div is the scroll container. Its padding is therefore part of the
 * scrollable area: content scrolls through it, above any `sticky top-0` child.
 * Little padding on top (0.5rem 1.5rem 1.5rem): the header's own bottom padding
 * already parts the content from the title. A panel that needs edge-to-edge
 * sticky headers can opt out with `className="!p-0"` and lay out its own
 * padding.
 */
const SlideOverBody = ({children, className = ''}) => {
    return (
        <div className={`relative px-6 pt-2 pb-6 flex-1 min-h-0 overflow-y-auto transition-opacity duration-200 ${className}`}>
            {children}
        </div>
    )
}

export default SlideOverBody
